import { last } from "lodash";
import { ICalendarSelectorGroup } from "../types";

const emptyGroup: ICalendarSelectorGroup = { id: "empty", name: "Empty", items: [], displayValues: [], values: [] };
export function getCurrentGroup(groups?: ICalendarSelectorGroup[]) {
  const activeGroup = groups && groups.find((x) => x.items.some((i) => i.active));
  return activeGroup || last(groups) || emptyGroup;
}
